import { ThemeProvider } from "@mui/material";
import { autostoreTheme, designSystemTheme } from "@qubit/autoparts";
import type { ReactNode } from "react";

import { useFlag } from "~/config/flags";

export function ASDSThemeProvider({ children }: { children: ReactNode }) {
  const { enableColorChanges } = useFlag();
  return (
    <ThemeProvider
      theme={enableColorChanges ? designSystemTheme : autostoreTheme}
    >
      {children}
    </ThemeProvider>
  );
}
